export default __webpack_public_path__ + "static/media/PSMT.0bf2ae4d.png";